import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

// src/plugins/vuetify.js
export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        // PRIMARY: The Brand (Buttons, Links, Active States)
        primary: "#6200EA", // Deep Purple

        // SECONDARY: The Content (Text, Headings, Icons)
        // CHANGED: From Purple/Black to a soft "Charcoal" for readability
        secondary: "#2D3748",

        // ACCENT: The Pop (Stars, Discounts, "New" tags)
        // CHANGED: To a warm Amber/Gold. Purple + Gold is a classic, premium combo.
        accent: "#FFB74D",

        // BACKGROUNDS
        background: "#F4F6F8", // Light Grey-Blue (Not pure white)
        surface: "#FFFFFF", // Pure White (For Cards)

        // STATUS
        info: "#00B8D4",
        success: "#4CAF50",
      },
      // If you MUST keep a dark mode, use these specific shades:
      dark: {
        primary: "#B388FF", // Light Lavender (Better contrast on dark)
        secondary: "#F5F5F5", // Off-White (For text - CRITICAL for readability)
        background: "#121212",
        surface: "#1E1E1E",
      },
    },
  },
});
